import React, { useMemo, useState } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import Typography from "components/typography";
import SearchInput from "components/inputs/search-input";
import Modal from "components/modal";
import Filter from "../filter";
import { IFilter } from "../..";
import PrimaryButton from "components/buttons/primary-button";
import { useNavigate } from "react-router-dom";
import { GetUser } from "services/user/getUser";

interface IProps {
  onChangeView: (viewType: string) => void;
  onChangeSearch: (value: string) => void;
  filter: IFilter;
  setFilter: (value: IFilter) => void;
}
const PageHeader = ({
  onChangeView,
  onChangeSearch,
  setFilter,
  filter
}: IProps) => {
  const [viewType, setViewType] = useState("list"); //block
  const [searchInput, setSeachInput] = useState("");
  const [isFilterOpen, setFilterOpen] = useState(false);

  const user = GetUser();

  const AddDisabled = useMemo(() => {
    if (user?.subscription === "free") {
      return true;
    }
    return false;
  }, [user?.subscription]);

  const navigate = useNavigate();

  const ChangeViewType = (viewType: string) => {
    onChangeView(viewType);
    setViewType(viewType);
  };

  return (
    <Container>
      <Header>
        <Typography
          color={Colors.white100}
          size="4xl"
          weight="bold"
          m_size="xl"
          mr="0.4"
        >
          R<span style={{ color: "#FF0050" }}>A</span>ted
        </Typography>
        <Typography
          color={Colors.white100}
          size="4xl"
          m_size="xl"
          weight="bold"
        >
          Fans
        </Typography>
      </Header>
      <FlexBox>
        <SearchContainer>
          <SearchInput
            placeholder="Search for a song, album or music video "
            value={searchInput}
            onChange={(e) => {
              setSeachInput(e.target.value);
              onChangeSearch(e.target.value);
            }}
          />
        </SearchContainer>
        <FilterContainer onClick={() => setFilterOpen(true)}>
          <FilterIcon>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M7.91602 11.6665C9.29677 11.6665 10.416 12.7858 10.416 14.1665C10.416 15.5472 9.29677 16.6665 7.91602 16.6665C6.53531 16.6665 5.41602 15.5472 5.41602 14.1665C5.41602 12.7858 6.53531 11.6665 7.91602 11.6665Z"
                stroke="white"
                stroke-width="1.25"
              />
              <path
                d="M12.084 3.3335C10.7032 3.3335 9.58398 4.45278 9.58398 5.8335C9.58398 7.2142 10.7032 8.3335 12.084 8.3335C13.4647 8.3335 14.584 7.2142 14.584 5.8335C14.584 4.45278 13.4647 3.3335 12.084 3.3335Z"
                stroke="white"
                stroke-width="1.25"
              />
              <path
                d="M12.5 14.1318H18.3333"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
              />
              <path
                d="M7.49935 5.79883H1.66602"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
              />
              <path
                d="M1.66602 14.1323H3.33268"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
              />
              <path
                d="M18.3327 5.79883H16.666"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
              />
            </svg>
          </FilterIcon>
          <Typography
            color={Colors.white300}
            weight="medium"
            m_display="none"
            ml="0.8"
          >
            Filter
          </Typography>
        </FilterContainer>
        <ViewTypeContainer>
          <ViewTypeItem
            active={viewType === "music" ? "true" : "false"}
            onClick={() => ChangeViewType("music")}
          >
            <ViewTypeIcon>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M7.5 15.8333C7.5 17.2141 6.38071 18.3333 5 18.3333C3.61929 18.3333 2.5 17.2141 2.5 15.8333C2.5 14.4526 3.61929 13.3333 5 13.3333C6.38071 13.3333 7.5 14.4526 7.5 15.8333Z"
                  stroke="currentColor"
                  stroke-width="1.25"
                />
                <path
                  d="M17.5 14.1667C17.5 15.5474 16.3807 16.6667 15 16.6667C13.6192 16.6667 12.5 15.5474 12.5 14.1667C12.5 12.7859 13.6192 11.6667 15 11.6667C16.3807 11.6667 17.5 12.7859 17.5 14.1667Z"
                  stroke="currentColor"
                  stroke-width="1.25"
                />
                <path
                  d="M7.5 15.8334V6.66669"
                  stroke="currentColor"
                  stroke-width="1.25"
                />
                <path
                  d="M17.5 14.1667V5"
                  stroke="currentColor"
                  stroke-width="1.25"
                />
                <path
                  d="M13.1126 3.1289L9.77925 4.24001C8.67925 4.60669 8.12919 4.79003 7.8146 5.22651C7.5 5.66299 7.5 6.24275 7.5 7.40229V9.99977L17.5 6.66643V6.29118C17.5 4.18079 17.5 3.1256 16.8078 2.62674C16.1157 2.12786 15.1147 2.46154 13.1126 3.1289Z"
                  stroke="currentColor"
                  stroke-width="1.25"
                  stroke-linecap="round"
                />
              </svg>
            </ViewTypeIcon>
          </ViewTypeItem>
          <ViewTypeItem
            active={viewType === "video" ? "true" : "false"}
            onClick={() => ChangeViewType("video")}
          >
            <ViewTypeIcon>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M1.66602 9.58331C1.66602 6.84375 1.66602 5.47396 2.42265 4.552C2.56117 4.38322 2.71592 4.22846 2.88471 4.08995C3.80667 3.33331 5.17645 3.33331 7.91602 3.33331C10.6556 3.33331 12.0253 3.33331 12.9473 4.08995C13.1161 4.22846 13.2708 4.38322 13.4093 4.552C14.166 5.47396 14.166 6.84375 14.166 9.58331V10.4166C14.166 13.1562 14.166 14.526 13.4093 15.448C13.2708 15.6167 13.1161 15.7715 12.9473 15.91C12.0253 16.6666 10.6556 16.6666 7.91602 16.6666C5.17645 16.6666 3.80667 16.6666 2.88471 15.91C2.71592 15.7715 2.56117 15.6167 2.42265 15.448C1.66602 14.526 1.66602 13.1562 1.66602 10.4166V9.58331Z"
                  stroke="currentColor"
                  stroke-width="1.25"
                />
                <path
                  d="M14.166 7.91684L14.7147 7.64253C16.3362 6.83174 17.147 6.42635 17.7398 6.79274C18.3327 7.15914 18.3327 8.06562 18.3327 9.8786V10.1218C18.3327 11.9348 18.3327 12.8412 17.7398 13.2076C17.147 13.574 16.3362 13.1686 14.7147 12.3579L14.166 12.0835V7.91684Z"
                  stroke="currentColor"
                  stroke-width="1.25"
                />
              </svg>
            </ViewTypeIcon>
          </ViewTypeItem>
        </ViewTypeContainer>

        <PrimaryButton
          onClick={() => navigate("/overview/rated-fans/customize-link")}
          iconPosition="left"
          iconSize="1.6"
          disabled={AddDisabled}
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M7.9987 14.6667C11.6806 14.6667 14.6654 11.6819 14.6654 8.00004C14.6654 4.31814 11.6806 1.33337 7.9987 1.33337C4.3168 1.33337 1.33203 4.31814 1.33203 8.00004C1.33203 11.6819 4.3168 14.6667 7.9987 14.6667Z"
                stroke="#FEA101"
                stroke-width="1.2"
              />
              <path
                d="M10 8H8M8 8H6M8 8V6M8 8V10"
                stroke="#FEA101"
                stroke-width="1.2"
                stroke-linecap="round"
              />
            </svg>
          }
          variant="p-fade"
          text="Add Page"
          m_iconButton
          fitContent
        />
      </FlexBox>

      <Modal isActive={isFilterOpen} closeModal={() => setFilterOpen(false)}>
        <Filter
          close={() => setFilterOpen(false)}
          setFilter={(value) => {
            setFilter(value);
          }}
          filter={filter}
        />
      </Modal>
    </Container>
  );
};

export default PageHeader;

const Container = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 1.6rem;
  border-bottom: 0.5px solid ${Colors.grey600};
  margin-bottom: 0.8rem;
  @media only screen and (max-width: 769px) {
    grid-template-columns: 100%;
    grid-row-gap: 1.6rem;
  }
`;

const Header = styled.div`
  display: inline-flex;
`;

const FlexBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
`;

const SearchContainer = styled.div`
  width: 30rem;
  margin-right: 1.2rem;
  @media only screen and (max-width: 769px) {
    width: 25rem;
  }
`;
const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  border-radius: 0.8rem;
  border: 1px solid ${Colors.grey600};
  padding: 0.9rem 0.8rem;
  margin-right: 1.2rem;
  cursor: pointer;
`;

const FilterIcon = styled.div`
  width: 2rem;
  height: 2rem;
`;
const ViewTypeContainer = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  border-radius: 0.8rem;
  border: 1px solid ${Colors.grey600};
  padding: 0.3rem;
  margin-right: 1.2rem;
`;

const ViewTypeItem = styled.div<{ active: string }>`
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.7rem;
  background: ${(props) => (props.active === "true" ? Colors.grey700 : "")};
  color: ${(props) =>
    props.active === "true" ? Colors.white100 : Colors.grey500};
  transition: all ease-in-out 0.15s;
`;

const ViewTypeIcon = styled.div`
  width: 2rem;
`;
